var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCutlery = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12",
  ref: ref
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "cutlery_svg__a",
  width: 12,
  height: 12,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h12v12H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#cutlery_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m2.188 10.5-.7-.7 5.125-5.125c-.15-.35-.171-.746-.063-1.188.108-.441.346-.837.713-1.187.441-.442.933-.7 1.475-.775.541-.075.983.058 1.325.4.341.342.474.783.4 1.325-.075.542-.334 1.033-.775 1.475-.35.367-.746.604-1.188.713-.442.108-.837.087-1.187-.063L6.688 6l3.8 3.8-.7.7-3.8-3.775-3.8 3.775Zm1.475-4.275-1.5-1.5a2.2 2.2 0 0 1-.675-1.612A2.2 2.2 0 0 1 2.163 1.5l3.1 3.125-1.6 1.6Z"
}))));
SvgCutlery.viewBox = '0 0 12 12';
const ForwardRef = /*#__PURE__*/forwardRef(SvgCutlery);
export default ForwardRef;